import '@mui/lab/themeAugmentation'

import { createTheme as createMuiTheme } from '@mui/material/styles'

import breakpoints from '@/theme/breakpoints'
import components from '@/theme/components'
import shadows from '@/theme/shadows'
import typography from '@/theme/typography'
import variants from '@/theme/variants'

declare module '@mui/material/styles' {
  interface TypeBackground {
    card: string
  }

  interface Palette {
    task: {
      completion: {
        background: string
        border: string
      }
      note: {
        background: string
        border: string
      }
    }
  }

  interface PaletteOptions {
    task?: {
      completion?: {
        background?: string
        border?: string
      }
      note?: {
        background?: string
        border?: string
      }
    }
  }
}

const createTheme = (name: string) => {
  let themeConfig = variants.find(variant => variant.name === name)
  if (!themeConfig) {
    console.warn(new Error(`The theme ${name} is not valid`))
    themeConfig = variants[0]
  }
  return createMuiTheme(
    {
      spacing: 4,
      breakpoints,
      // @ts-expect-error Incompatible types
      components,
      typography,
      shadows,
      palette: themeConfig.palette,
    },
    {
      name: themeConfig.name,
      header: themeConfig.header,
      footer: themeConfig.footer,
      sidebar: themeConfig.sidebar,
    },
  )
}

export default createTheme
